module.exports = __webpack_public_path__ + "static/img/ririying_banner.b9aeb6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commission/ririying_banner.png
// module id = 3SDs
// module chunks = 69